import React from "react";
import { Box, Button, Container, Divider, Typography } from "@mui/material";
import { AuthContainer, AuthWrapper } from "../styles";
import { useNavigate, useSearchParams } from "react-router-dom";
import UpdatePassword from "./UpdatePassword";
import RequestReset from "./RequestReset";
const ResetPassword = () => {
	const [searchParams] = useSearchParams();
	const resetToken = searchParams.get("reset_token");
	const navigate = useNavigate();

	return (
		<Container>
			<AuthContainer>
				<AuthWrapper>
					{resetToken ? (
						<Box className={"left_block"}>
							<UpdatePassword token={resetToken} />
						</Box>
					) : (
						<Box className={"left_block"}>
							<RequestReset />
						</Box>
					)}
					<Box className={"right_block"}>
						{resetToken ? (
							<>
								<Typography variant={"h4"}>Update Password</Typography>
								<Typography variant={"subtitle2"} textAlign={"center"}>
									Submit your new password
								</Typography>
							</>
						) : (
							<>
								<Typography variant={"h4"}>Reset Password</Typography>
								<Typography variant={"subtitle2"} textAlign={"center"}>
									You will receive instructions for resetting your password
								</Typography>
								<Box width={"100%"} my={2}>
									<Divider color={"#ffffff"} />
								</Box>
							</>
						)}

						<Box mt={0}>
							<Button variant={"contained"} size={"large"} onClick={() => navigate("/login")}>
								Login
							</Button>
						</Box>
					</Box>
				</AuthWrapper>
			</AuthContainer>
		</Container>
	);
};

export default ResetPassword;
